module.exports = __webpack_public_path__ + "media/34.4f072761.mp3";